import type { PartAuthentication } from '@/types/Part';

interface AuthRecordProps {
  auth: PartAuthentication;
}

export default function AuthRecord({ auth }: AuthRecordProps) {
  const dateStr = auth.verifiedDate?.toDate
    ? auth.verifiedDate.toDate().toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      })
    : '—';

  return (
    <div className="auth-record">
      <h4>✓ Authentication Record</h4>
      <dl>
        <dt>Verified by</dt>
        <dd>{auth.verifiedBy || '—'}</dd>
        <dt>Date</dt>
        <dd>{dateStr}</dd>
        <dt>Notes</dt>
        <dd>{auth.notes || '—'}</dd>
      </dl>
    </div>
  );
}
